




















import {Component, Vue, Prop} from "vue-property-decorator";

import {checkLSBooleanValue, updateLSBoolValue} from "@/helpers/localStoragehandler";

@Component({
  name: 'ShipmentHelperText',
  components: {
  },
})
export default class ShipmentHelperText extends Vue {
  private showMessage: boolean = true;
  @Prop({ default: 'SHIPMENT_HELPER_HIDE_INFO' })
  private lsHideInfoId!: string;

  private created() {
    this.showMessage = !checkLSBooleanValue(this.lsHideInfoId);
  }

  private toggleShowInfo() {
    this.showMessage = !this.showMessage;
    updateLSBoolValue(this.lsHideInfoId, !this.showMessage); // Save value in local storage
  }
}
